/**
 * v4.8.1 — Demo Route Guard.
 *
 * Higher-order wrapper for routes that should be hidden while Master
 * Demo Mode is active. If the calling user has demo mode on, renders
 * the calm <DemoUnavailable/> placeholder instead of the real children.
 *
 * Usage:
 *     <Route path="/surveys" element={
 *         <DemoRouteGuard>
 *             <Layout><Surveys/></Layout>
 *         </DemoRouteGuard>
 *     } />
 *
 * The curated investor allowlist is enforced at the route-rendering
 * layer (here) AND at the capability-map / sidebar layer (backend).
 * Two independent guards — defence in depth.
 */
import React from "react";
import { useDemoMode } from "./DemoModeContext";
import DemoUnavailable from "./DemoUnavailable";

export const DemoRouteGuard = ({ children }) => {
    const { active, loaded } = useDemoMode();
    // Until the initial GET resolves, render children — avoids flashing
    // the placeholder for users who don't have demo access at all.
    if (loaded && active) {
        return <DemoUnavailable />;
    }
    return <>{children}</>;
};

export default DemoRouteGuard;
